import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import AOS from 'aos';

import 'slick-carousel';
import 'Lib/jquery.jConveyorTicker.min';

import OneVideo from 'Modules/module-oneVideo';

"use strict";

var viewAbout = Backbone.View.extend({

    initialize: function(opts){
        var self = this;
        self.$content = self.$el;
        self.$body = $('body');
        self.$header = $('header');
        self.imageCarousel(self.$content.find('.three-images'),true);
        self.imageCarousel(self.$content.find('.moments-module'));

        // self.initVideo();
        self.collectionCarousel();
        self.quotes();
        
    },

    events: {
        
    },

    imageCarousel: function(selector,mobileOnly){
        var self = this;
        self.$imageModule = selector;

        if(mobileOnly){
            if(self.isMobile()){

                self.$imageModule.slick({
                    dots: true,
                    arrows: false,
                    infinite: true,
                    speed: 400,
                    slidesToShow: 1,
                    fade: true,
                    centerMode: false,
                    autoplay: true,
                    autoplaySpeed: 6000,
                    variableWidth: false
                });

            }
        }else{

            self.$imageModule.slick({
                dots: true,
                arrows: false,
                infinite: true,
                speed: 400,
                slidesToShow: 1,
                fade: true,
                centerMode: false,
                autoplay: true,
                autoplaySpeed: 6000,
                variableWidth: false
            });

        }
        AOS.refresh();

    },

    collectionCarousel: function(){
        var self = this;
        var slickSettings = {
            arrows: true,
            dots: false,
            infinite: true,
            speed: 400,
            slidesToShow: 1,
            centerMode: true,
            autoplay: true,
            autoplaySpeed: 6000,
            slidesToScroll: 2,
            variableWidth: false
        };

        self.$featuredCollection = self.$content.find('.collection-carousel');

        if(!self.isMobile()){
            //Ticker found @ https://www.jqueryscript.net/animation/horizontal-animation-conveyor-ticker.html
            self.$featuredCollection.find('.collection-product-list').jConveyorTicker({
                anim_duration: 300
            });
        }else{
            self.$featuredCollection.find('.collection-product-list').find('ul').slick(slickSettings);
        }
        AOS.refresh();
    },

    quotes: function() {
        let self = this;
        self.$productScrollModule = self.$content.find('.quotes');
        self.$productScrollCarousel = self.$productScrollModule.find('.quotes-carousel');

        self.$productScrollCarousel.slick({
            infinite: true,
            arrows: true,
            slidesToShow: 1,
        }) 
    },

    initVideo: function(){
        var self = this;
        self.$videoBoxes = $('.media_and_text').find('.video-box');
        
        OneVideo.init({
            el: self.$videoBoxes
        });

        if(self.isMobile()){

            _.each($('.media_and_text').find('.poster-image'), function(posterImgs){
                var thePoster = $(posterImgs).attr('data-poster');
                if(typeof thePoster !== 'undefined' && thePoster.length){
                    $(posterImgs).css({ 'background-image': 'url('+ thePoster +')' });
                }
                thePoster = "";
            });
        }
    },
    
    isMobile: function () {
        var self = this;
        var w = $(window).width();
        if (w <= ORW.responsiveSizes.large) {
            return true;
        }
        return false;
    }

});

export default viewAbout;